<!--
  Empty states that say what to do next. "Nothing here" is not a state, it is a
  shrug.
-->
<script lang="ts">
  import type { Snippet } from 'svelte';
  import Icon, { type IconName } from './Icon.svelte';

  interface Props {
    icon?: IconName;
    title: string;
    detail?: string;
    /** Actions: buttons or links, laid out in a row. */
    children?: Snippet;
    tone?: 'neutral' | 'bad';
  }

  let { icon = 'film', title, detail, children, tone = 'neutral' }: Props = $props();
</script>

<div class="empty {tone}">
  <span class="glyph"><Icon name={icon} size={22} /></span>
  <h3>{title}</h3>
  {#if detail}<p>{detail}</p>{/if}
  {#if children}
    <div class="actions">{@render children()}</div>
  {/if}
</div>

<style>
  .empty {
    display: grid;
    justify-items: center;
    gap: 6px;
    padding: 44px 24px;
    text-align: center;
  }
  .glyph {
    display: grid;
    place-content: center;
    width: 44px;
    height: 44px;
    margin-bottom: 6px;
    border-radius: 50%;
    background: var(--surface-2);
    color: var(--text-faint);
  }
  .bad .glyph {
    background: color-mix(in oklab, var(--bad) 14%, var(--surface-2));
    color: var(--bad);
  }
  h3 {
    font-size: 0.95rem;
    font-weight: 600;
  }
  p {
    max-width: 42ch;
    color: var(--text-dim);
    font-size: 0.85rem;
    line-height: 1.5;
  }
  .actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    margin-top: 10px;
  }
</style>
